import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from "prop-types";
import Select from 'react-select';

// el estilo de "select" de react-select al quedar "disabled" era distinto al resto de inputs
const disabledSelectStyle = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: state.isDisabled ? '#e9ecef' : provided.backgroundColor,
        color: state.isDisabled ? '#495057' : provided.color,
        cursor: state.isDisabled ? 'not-allowed' : provided.cursor,
        borderColor: state.isDisabled ? '#ced4da' : provided.borderColor,
        boxShadow: 'none',
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: state.isDisabled ? '#495057' : provided.color,
    })
};

const VehicleForm = ({
                         brand,
                         model,
                         year,
                         listMarcas = [],
                         listModelos = [],
                         isHomologated = false,
                         homologatedBrand = null,
                         homologatedModel = null,
                         homologatedCarsList = [],
                         brandExists = false,
                         modelExists = false,
                         modelId = '',
                         hgtedBrandNotFound = false,
                         hgtedModelNotFound = false,
                         onChangeMarca,
                         onChangeModel,
                         onChangeYear,
                         calculateMaxYear
                     }) => {
    return (
        <Row>
            {/* Brand Select */}
            <Col md={4}>
                <div className="form-group">
                    <label className="labe-simulation-home" htmlFor="brand">Marca</label>
                    <Select
                        isDisabled={brandExists}
                        onChange={(option) => onChangeMarca({ target: { value: option?.value || '' } })}
                        value={brand ? {
                            value: brand,
                            label: isHomologated
                                ? homologatedBrand?.homologatedBrandName
                                : listMarcas.find(m => String(m.VemCodigoMarca) === brand)?.VeMNombre || ''
                        } : null}
                        options={isHomologated && (homologatedCarsList.length > 0 || homologatedBrand)
                            ? [{
                                value: homologatedBrand?.brandId || '',
                                label: homologatedBrand?.homologatedBrandName || 'Seleccione marca homologada'
                            }]
                            : [
                                { value: '', label: 'Seleccione marca' },
                                ...listMarcas.map(marca => ({
                                    value: String(marca.VemCodigoMarca),
                                    label: marca.VeMNombre
                                }))
                            ]}
                        id="brand"
                        name="brand"
                        required
                        placeholder="Seleccione marca"
                        isSearchable={true}
                        isClearable={true}
                        noOptionsMessage={() => "No se encontraron marcas"}
                        styles={disabledSelectStyle}
                    />
                    {hgtedBrandNotFound && (
                        <div className="text-danger small mt-1">
                            Marca no homologada, por favor seleccione la marca.
                        </div>
                    )}
                </div>
            </Col>

            {/* Model Select */}
            <Col md={4}>
                <div className="form-group">
                    <label htmlFor="model" className="labe-simulation-home">Modelo</label>
                    <Select
                        isDisabled={modelExists || !listModelos.length || (isHomologated && modelId)}
                        onChange={(option) => onChangeModel({ target: { value: option?.value || '' } })}
                        value={model ? {
                            value: model,
                            label: isHomologated
                                ? homologatedModel?.homologatedModelName || homologatedCarsList.find(m => String(m.modelId) === model)?.homologatedModelName
                                : listModelos.find(m => String(m.VMoCodigoModelo) === String(model))?.VMoModelo || ''
                        } : null}
                        options={isHomologated && homologatedCarsList.length > 0
                            ? [
                                { value: '', label: 'Seleccione Modelo' },
                                ...homologatedCarsList.map(modelo => ({
                                    value: String(modelo.modelId),
                                    label: modelo.homologatedModelName
                                }))
                            ]
                            : [
                                { value: '', label: 'Seleccione Modelo' },
                                ...listModelos.map(modelo => ({
                                    value: String(modelo.VMoCodigoModelo),
                                    label: modelo.VMoModelo
                                }))
                            ]}
                        id="model"
                        name="model"
                        placeholder="Seleccione Modelo"
                        isSearchable={true}
                        isClearable={true}
                        required
                        noOptionsMessage={() => "No se encontraron modelos"}
                        styles={disabledSelectStyle}
                    />
                    {hgtedModelNotFound && (
                        <div className="text-danger small mt-1">
                            Modelo no homologado, por favor seleccione el modelo.
                        </div>
                    )}
                </div>
            </Col>

            {/* Year Input */}
            <Col md={4}>
                <div className="form-group">
                    <label className="labe-simulation-home" htmlFor="year">Año</label>
                    <input
                        disabled={modelExists}
                        type="number"
                        required
                        onChange={onChangeYear}
                        value={year}
                        id="year"
                        name="year"
                        className="form-control"
                        placeholder="Año del vehículo"
                        min="1980"
                        max={calculateMaxYear()}
                        aria-label="Año del vehículo"
                    />
                </div>
            </Col>
        </Row>
    );
};

// Prop Types
VehicleForm.propTypes = {
    // Values
    brand: PropTypes.string,
    model: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    // Options
    listMarcas: PropTypes.arrayOf(
        PropTypes.shape({
            VemCodigoMarca: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            VeMNombre: PropTypes.string
        })
    ),
    listModelos: PropTypes.arrayOf(
        PropTypes.shape({
            VMoCodigoModelo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            VMoModelo: PropTypes.string
        })
    ),

    // Homologation
    isHomologated: PropTypes.bool,
    homologatedBrand: PropTypes.shape({
        brandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        homologatedBrandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        homologatedBrandName: PropTypes.string
    }),
    homologatedModel: PropTypes.shape({
        modelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        homologatedModelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        homologatedModelName: PropTypes.string
    }),
    homologatedCarsList: PropTypes.arrayOf(
        PropTypes.shape({
            brandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            modelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            homologatedModelName: PropTypes.string
        })
    ),

    // State flags
    brandExists: PropTypes.bool,
    modelExists: PropTypes.bool,
    modelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hgtedBrandNotFound: PropTypes.bool,
    hgtedModelNotFound: PropTypes.bool,

    // Handlers
    onChangeMarca: PropTypes.func.isRequired,
    onChangeModel: PropTypes.func.isRequired,
    onChangeYear: PropTypes.func.isRequired,
    calculateMaxYear: PropTypes.func.isRequired
};

// Default Props
VehicleForm.defaultProps = {
    listMarcas: [],
    listModelos: [],
    isHomologated: false,
    homologatedCarsList: [],
    brandExists: false,
    modelExists: false,
    hgtedBrandNotFound: false,
    hgtedModelNotFound: false
};

export default VehicleForm;